var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-center text-404"},[_vm._v("404")]),_c('h3',{staticClass:"text-center text-404-description"},[_vm._v(_vm._s(_vm.$t('pages.page.not_found_page')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }